import { env } from '@/shared/config'

import { ChatAPIMock } from './mock'
import { ChatAPIRemote } from './remote'
import type { ChatAPI } from './types'

export * from './effect'
export * from './protocol'
export * from './types'

function getAPI(): ChatAPI {
    if (env.MOCK_API_ENABLE) {
        return new ChatAPIMock()
    }
    return new ChatAPIRemote()
}

export const chatapi: ChatAPI = getAPI()
